import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, Optional } from '@angular/core';
import { Subscription } from 'rxjs';
import { MLayoutService } from './layout.service';
import { IMenu } from './layout.type';
@Component({
  selector: 'm-layout-menu',
  template: `
    <ng-container *ngIf="showMenu && menuContent.length; else elseTemplate">
      <ul nz-menu nzMode="inline">
        <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menuContent, level: 1 }"></ng-container>
        <ng-template #menuTpl let-menuContent let-level="level">
          <ng-container *ngFor="let menu of menuContent; let idx = index">
            <li
              *ngIf="menu.children && menu.children.length; else subMenu"
              nz-submenu
              class="m-layout-menu-sub"
              [nzPaddingLeft]="paddingLeft"
              [(nzOpen)]="menu.open"
              [nzTitle]="parentMenu"
            >
              <ul>
                <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children, level: level + 1 }"></ng-container>
              </ul>
            </li>
            <ng-template #parentMenu>
              <i nz-icon class="m-layout-menu-arrow" [ngClass]="{ 'm-layout-menu-arrow-rotate': menu.open }">
                <svg
                  width="5px"
                  height="8px"
                  viewBox="0 0 5 8"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <defs>
                    <filter id="m-layout-menu-arrow">
                      <feColorMatrix
                        in="SourceGraphic"
                        type="matrix"
                        values="0 0 0 0 0.466667 0 0 0 0 0.521569 0 0 0 0 0.572549 0 0 0 1.000000 0"
                      ></feColorMatrix>
                    </filter>
                  </defs>
                  <g id="控件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="2.Nav树导航/导航状态/一级菜单-收起" transform="translate(-11.000000, -16.000000)">
                      <g id="编组-4" transform="translate(6.000000, 9.000000)">
                        <g
                          id="Icon/Fill/file-code"
                          transform="translate(8.000000, 11.000000) rotate(-90.000000) translate(-8.000000, -11.000000) translate(0.000000, 3.000000)"
                          filter="url(#m-layout-menu-arrow)"
                        >
                          <g>
                            <rect id="矩形" fill="#000000" fill-rule="nonzero" opacity="0" x="0" y="0" width="16" height="16"></rect>
                            <path
                              d="M8.09510524,5.71333333 L11.1302105,9.76014033 C11.1964847,9.84850589 11.178576,9.97386616 11.0902105,10.0401403 C11.0555913,10.0661048 11.0134845,10.0801403 10.9702105,10.0801403 L4.9,10.0801403 C4.78954305,10.0801403 4.7,9.99059728 4.7,9.88014033 C4.7,9.83686628 4.71403557,9.79475956 4.74,9.76014033 L7.77510524,5.71333333 C7.84137941,5.62496777 7.96673968,5.60705916 8.05510524,5.67333333 C8.07026638,5.68470418 8.08373439,5.6981722 8.09510524,5.71333333 Z"
                              id="Icon/Fill/arrow-down"
                              fill="#FFFFFF"
                              transform="translate(7.935105, 7.790070) scale(1, -1) translate(-7.935105, -7.790070) "
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </i>
              <i nz-icon class="m-layout-menu-icon" [nzType]="menu.icon" *ngIf="menu.icon"></i>
              <span>{{ menu.title }}</span>
            </ng-template>
            <ng-template #subMenu>
              <li
                *ngIf="!menu.divider; else dividerMenu"
                nz-menu-item
                [nzPaddingLeft]="level === 1 ? paddingLeft : logoSize + logoMargin + (level - 1) * paddingLeft"
                class="m-layout-menu-item"
                [routerLink]="menu.link"
                [nzSelected]="menu.selected"
                [nzMatchRouter]="true"
                (click)="onMenuClick(menu)"
                [nzMatchRouterExact]="menu.matchRouterExact"
              >
                <i nz-icon [nzType]="menu.icon" *ngIf="menu.icon"></i>
                <span>{{ menu.title }}</span>
              </li>
            </ng-template>
            <ng-template #dividerMenu>
              <li nz-menu-divider></li>
            </ng-template>
          </ng-container>
        </ng-template>
      </ul>
      <div class="m-layout-menu-toggle" (click)="toggleMenuClick()">
        <i nz-icon>
          <svg
            width="16px"
            height="62px"
            viewBox="0 0 16 62"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="2-2悬浮显示2级收起" transform="translate(-153.000000, -337.000000)">
                <g id="编组-8" transform="translate(153.000000, 337.000000)">
                  <g
                    id="编组-9"
                    transform="translate(8.000000, 31.000000) scale(-1, 1) translate(-8.000000, -31.000000) "
                    fill="#EDF2F6"
                    stroke="#E4EBF1"
                  >
                    <g id="编组-4" transform="translate(8.000000, 31.000000) scale(-1, 1) translate(-8.000000, -31.000000) ">
                      <path
                        d="M15.5,0.902123821 L15.5,61.0978762 L2.14500371,52.7510035 C1.12166894,52.1114193 0.5,50.9897745 0.5,49.7830094 L0.5,49.7830094 L0.5,12.2169906 C0.5,11.0102255 1.12166894,9.88858073 2.14500371,9.2489965 L2.14500371,9.2489965 L15.5,0.902123821 Z"
                        id="矩形"
                      ></path>
                    </g>
                  </g>
                  <path
                    d="M13.0505772,30.7071068 L13.757684,31.4142136 L8.50512265,36.6667749 L3.25256133,31.4142136 L3.95966811,30.7071068 L8.50466811,35.2516681 L13.0505772,30.7071068 Z M12.7980159,26 L13.5051227,26.7071068 L8.25256133,31.9596681 L3,26.7071068 L3.70710678,26 L8.25210678,30.5441068 L12.7980159,26 Z"
                    id="形状结合"
                    fill="#4C5E70"
                    fill-rule="nonzero"
                    transform="translate(8.378842, 31.333387) scale(-1, 1) rotate(-90.000000) translate(-8.378842, -31.333387) "
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </i>
      </div>
    </ng-container>
    <ng-template #elseTemplate>
      <div class="m-layout-menu-hidden">
        <i nz-icon (click)="toggleMenuClick()">
          <svg
            width="16px"
            height="6px"
            viewBox="0 0 16 6"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="m-layout-menu-hidden" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="m-layout-menu-hidden" transform="translate(-8.000000, -57.000000)" fill="#D5DEE7">
                <path
                  d="M24,62 L24,63 L8,63 L8,62 L24,62 Z M24,59.5 L24,60.5 L8,60.5 L8,59.5 L24,59.5 Z M24,57 L24,58 L8,58 L8,57 L24,57 Z"
                  id="形状结合"
                ></path>
              </g>
            </g>
          </svg>
        </i>
      </div>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true,
  exportAs: 'mLayoutMenu',
  host: {
    class: 'm-layout-menu',
    '[class.m-layout-menu-close]': 'close',
    '[style.width.px]': 'showMenu ? width: hiddenMenuWidth',
    '[style.padding-top.px]': 'showMenu ? paddingTop: 0'
  }
})
export class MLayoutMenuComponent implements OnDestroy {
  subscription = new Subscription();
  menuContent: IMenu[] = [];
  close = false;
  showMenu = true;
  width = 168;
  hiddenMenuWidth = 28;
  paddingTop = 16;
  paddingLeft = 27;
  logoSize = 16;
  logoMargin = 4;
  constructor(private layoutService: MLayoutService, @Optional() public cdr: ChangeDetectorRef) {
    this.subscription.add(
      this.layoutService.sideMenuClick$.subscribe((child: IMenu[]) => {
        this.menuContent = child;
        this.showMenu = true;
        this.close = !this.menuContent.length;
        this.cdr?.markForCheck();
      })
    );
  }

  onMenuClick(menu: IMenu): void {
    menu.selected = true;
  }

  toggleMenuClick(): void {
    this.showMenu = !this.showMenu;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
